<div class="section">
    <h1 class="section-title" *ngIf="sectionTitle">{{sectionTitle}}</h1>
    <div class="row">
      <div class="col-md-6 col-lg-4" *ngFor="let newsArticle of newsArticles; index as i; first as isFirst">
        <csl-feature-post-main *ngIf="i<6" [topNewsArticle] ="newsArticle" [articleHeight] ="300" [routeGoal]="routeGoal"></csl-feature-post-main>
      </div>
    </div>
</div><!--/.section -->
  